// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h446t","content":"styles_content__VVaak","tableWrap":"styles_tableWrap__3ei4a"};